<template>
  <div>
    <div v-for="(rule, index) in rules" :key="`${rule.title}${index}`" class="not-first:mt-4">
      <div class="font-bold mb-2">{{ rule.title }}</div>
      <BulletText class="pl-3" :content="rule.contentList" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BulletText from '@/components/common/bullet-text.vue'

interface Props {
  rules: {
    title: string
    contentList: string[]
  }[]
}

defineProps<Props>()
</script>
